export default __webpack_public_path__ + "static/media/plus_icon.0c1cff63.svg";